/**
 * 滚动开奖
 */


import luckGrid from './index.vue';
export { luckGrid };
export default luckGrid;
